import { useState, useEffect } from "react";

export function OfflineBar() {
  const [offline, setOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const goOffline = () => setOffline(true);
    const goOnline = () => setOffline(false);
    window.addEventListener("offline", goOffline);
    window.addEventListener("online", goOnline);
    return () => {
      window.removeEventListener("offline", goOffline);
      window.removeEventListener("online", goOnline);
    };
  }, []);

  if (!offline) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        background: "#C0392B",
        color: "#fff",
        padding: "8px 16px",
        textAlign: "center",
        zIndex: 9999,
        fontSize: "0.85rem",
      }}
    >
      📡 Keine Internetverbindung
    </div>
  );
}
